import { Loading } from '@perch-labs/shrike';
import { Title, Description } from '~/components/typography';
import { IS_PERCH_ENERGY } from '~/utils/constants';
import { Wrapper } from '../errors/error.util';

export const IpaRedirect = () => {
  return (
    <Wrapper testId="screen-IpaRedirect">
      <Title textAlign="center" marginTop="48px">
        Please hold on while we process your response. This may take a few seconds.
      </Title>
      {!IS_PERCH_ENERGY && (
        <>
          <Description textAlign="center" marginTop="24px" />
          <Loading />
        </>
      )}
    </Wrapper>
  );
};
